<template>
  <div>
    <div class="title" style="padding: 0; border: 0">{{ info.title }}</div>
    <div class="notice">{{ info.description }}</div>
    <div class="but">
      <div v-for="item in info.buttons" :key="item.target">
        <img
          v-if="item.isAction"
          src="../../../public/img/newPages/guanzhu1.png"
          alt=""
          class="tcollected"
          @click="iconClick(info, item)"
        />
        <img
          v-else
          src="../../../public/img/newPages/guanzhu.png"
          alt=""
          class="tcollected"
          @click="iconClick(info, item)"
        />
        <span>收藏</span>
      </div>
      <div></div>
      <ShareCom />
    </div>
    <!-- <div v-if="info.isVip" class="pay">
      <div v-if="info.codeImg" class="codeImg"><img :src="info.codeImg" /></div>
      <div class="payCon">
        <div class="buyVipBtn" @click="buyVipClick(info)">
          开通VIP会员免费观看
        </div>
        <div class="payText">支付宝或微信扫码，支付成功刷新页面即可观看</div>
      </div>
    </div> -->
    <slot name="dramas"></slot>
  </div>
</template>

<style lang="scss" scoped>
.videoNow {
  width: 340px;
  box-sizing: border-box;
  background: #10131a;
}
.title {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 10px 15px;
  border: solid 1px #1e212a;
  text-align: left;
}
.title > span,
.contentTitle {
  color: #fff;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
}
.title > ul {
  overflow: hidden;
  margin: 0px;
}
.title > ul li {
  float: left;
  list-style: none;
  cursor: pointer;
}
.title > ul img {
  width: 20px;
  height: 20px;
  margin-right: 10px;
  cursor: pointer;
}
.content {
  display: flex;
  box-sizing: border-box;
  padding: 10px 15px;
  text-align: left;
  overflow: hidden;
}
.content .total {
  position: absolute;
  bottom: 5px;
  right: 5px;
  background: #f36264;
  padding: 1px 3px;
  color: #fff;
  font-size: 10px;
}

.content > .img {
  width: 148px;
  height: 82px;
  position: relative;
}
.content > .img > img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.content > .video-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-sizing: border-box;
  padding-left: 10px;
}
.contentTitle {
  font-size: 13px;
  padding-bottom: 20px;
}
.video-name {
  width: 148px;
  font-size: 14px;
  color: #fff;
}
.price {
  color: #daad75;
  line-height: 33px;
  height: 33px;
  font-size: 14px;
}
.price span {
  font-size: 16px;
  color: #f8002c;
}

.purchase {
  & > button {
    width: 148px;
    padding: 6px 10px;
    border-radius: 20px;
    font-size: 12px;
    border: none;
    background: #daad75;
    color: #000;
    cursor: pointer;
  }
  .unable-purchase {
    background: #dcdfe6;
  }
}
.viewCounts {
  display: block;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.7);
}
.viewCounts > img {
  width: 12px;
  height: 12px;
  transform: translate(0, -5px);
}
.pay {
  width: 100%;
  padding: 10px 20px;
  box-sizing: border-box;
  background: #161a21;
  overflow: hidden;
}
.pay .codeImg,
.pay .payCon {
  float: left;
}
.codeImg {
  width: 100px;
  height: 100px;
  margin-right: 20px;
}
.codeImg > img {
  width: 100%;
  height: 100%;
}
.payCon {
  height: 100px;
  width: 190px;
}
.payCon .buyVipBtn {
  text-align: center;
  width: 190px;
  height: 30px;
  background-image: linear-gradient(to bottom, #f1d09f 0%, #cca16a 100%);
  line-height: 30px;
  font-size: 10px;
  border-radius: 25px;
  margin-bottom: 20px;
  cursor: pointer;
}
.payCon .payText {
  font-size: 10px;
}
</style>

<script>
import ShareCom from "./../zhangqi/ShareCom.vue";
import Dramas from "./dramas.vue";
import { getUser } from "../../utils/auth.js";

export default {
  props: {
    info: Object,
  },
  components: { ShareCom, Dramas },
  computed: {
    viewCounts() {
      var n = this.info.viewCounts;
      return n > 10000 ? (n / 10000).toFixed(1) + "万" : n;
    },
  },
  data() {
    return {
      headerIdx: 0,
    };
  },
  mounted() {
    console.log(this.info);
  },
  methods: {
    iconClick(info, item) {
      console.log(info.buttons[0].isAction);
      if (info.buttons[0].isAction == false && getUser()) {
        item.isAction = true;
      } else if (info.buttons[0].isAction == true && getUser()) {
        item.isAction = true;
      } else {
        item.isAction = false;
      }
      this.$emit("iconClick", { info: info, button: item });
    },
    buyVipClick(info) {
      this.$emit("buyVipClick", info);
    },
    // 购买视频
    purchase(e) {
      if (this.info.permission) {
        this.$message.info("此视频您已购买");
        return;
      }
      if (getUser()) {
        // 通知去支付
        this.callPay("", e);
      } else {
        this.callLogin("请先登录");
      }
    },
    // 去登录
    callLogin(msg) {
      this.$message({
        message: msg,
        type: "warning",
        duration: 1000,
        onClose: () => {
          this.$emit("login");
        },
      });
    },
    // 去购买/开通VIP
    callPay(msg, type) {
      if (msg) {
        this.$message({
          message: msg,
          type: "warning",
          duration: 1000,
          onClose: () => {
            this.$emit("purchase", type ? type : "vip");
          },
        });
      } else {
        this.$emit("purchase", type);
      }
    },
  },
};
</script>
